(ns practitest.frontend.components2.dashboard.charts.age
  (:require [practitest.frontend.components2.dashboard.charts.render :as r]
            [practitest.frontend.components2.dashboard.charts.common :as c]
            [practitest.frontend.components2.dashboard.charts.stacked-bar :as stacked-bar]
            [practitest.frontend.components2.dashboard.chart :as-alias chart]
            [practitest.frontend.components2.dashboard.charts.protocol :as p]
            [practitest.frontend.components2.dashboard.transforms.age :as transforms]
            [practitest.frontend.components2.dashboard.events :as-alias events]
            [re-frame.core :as rf]))

(def chart-custom-spec
  {:encode {:tooltip {:mode :category-value}}})

(defmethod p/render! ::chart/age [chart _ctx svg-element]
  (let [nav-evt #(rf/dispatch [::events/navigate chart %])
        spec    (-> (c/deep-merge (stacked-bar/base-spec chart) chart-custom-spec)
                    (assoc :on-bar-click nav-evt))]
    (r/render-chart! svg-element spec)))

(defmethod p/transform-data ::chart/age [chart]
  (transforms/transform chart))

(derive ::chart/age ::chart/stacked-bar)
